import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import availableBalance from '@/components/wallet/available-balance/available-balance.vue';
import bankLinks from '@/components/wallet/bank-links/bank-links.vue';
import withdrawAchDisclaimer from '@/components/wallet/shared/withdraw-ach-disclaimer/withdraw-ach-disclaimer.vue';
import withdrawConfirm from '@/components/wallet/withdraw-confirm/withdraw-confirm.vue';
import defaultInstitutionLogo from '@/assets/icons/bank.svg';
import { formMixin, validators } from '@/components/forms/mixin';
import contentLoaderMixin from '@/mixins/contentLoader';
import documentUploadMixin from '@/mixins/documentUpload';
import withdrawWarningMixin from '@/mixins/withdrawWarning';
import { roundDown } from '@/utils/helpers';

const STEPS = {
  SELECT_ACCOUNT: 1,
  ENTER_AMOUNT: 2,
  REVIEW: 3,
};

export default {
  mixins: [
    contentLoaderMixin,
    documentUploadMixin,
    formMixin,
    withdrawWarningMixin,
  ],
  components: {
    alertBox,
    availableBalance,
    bankLinks,
    withdrawAchDisclaimer,
    withdrawConfirm,
  },
  data() {
    return {
      amount: '',
      currentStep: STEPS.SELECT_ACCOUNT,
      defaultInstitutionLogo,
      error: '',
      selectedAccount: null,
      STEPS,
    };
  },
  validations() {
    return {
      amount: validators.withdrawalAmount(
        this.minimumWithdrawal,
        this.maximumWithdrawal,
      ),
    };
  },
  computed: {
    ...mapState('wallet', ['ach']),
    accountDetails() {
      if (!this.selectedAccount) return {};
      return {
        accountLastFourDigits: this.selectedAccount.accountNumberLastFour,
        institutionName: this.selectedAccount.institutionName || 'Bank account',
        linkedBankAccountId: this.selectedAccount.linkedBankAccountId,
      };
    },
    availableBalance() {
      return this.ach && this.ach.availableFundsString
        ? this.ach.availableFundsString
        : '$0.00';
    },
    maximumWithdrawal() {
      return this.ach
        ? roundDown(this.ach.availableFunds || 0)
        : 0;
    },
    minimumWithdrawal() {
      return this.maximumWithdrawal > 0 ? 1 : 0;
    },
    isAmountFieldDisabled() {
      return this.minimumWithdrawal < 1 || this.maximumWithdrawal < 1;
    },
    restrictedFunds() {
      return this.ach && this.ach.restrictedFundsString
        ? this.ach.restrictedFundsString
        : '';
    },
    errorMessage() {
      return this.error || (this.ach && this.ach.errorMessage) || '';
    },
    hasErrorMessage() {
      return !!this.errorMessage;
    },
  },
  methods: {
    ...mapActions('wallet', ['getWithdrawAch']),
    accountDescription(account) {
      if (!account) return 'Bank account';
      const accountName = account.accountName ||
        account.accountType ||
        'Bank account';
      return account.accountNumberLastFour
        ? `${accountName} - ${account.accountNumberLastFour}`
        : accountName;
    },
    selectAccount(account) {
      this.selectedAccount = account;
      this.amount = '';
      this.currentStep = STEPS.ENTER_AMOUNT;
      this.$nextTick(() => this.$v.amount.$reset());
    },
    returnToAccounts() {
      this.amount = '';
      this.selectedAccount = null;
      this.currentStep = STEPS.SELECT_ACCOUNT;
      this.$nextTick(() => this.$v.amount.$reset());
    },
    reviewRequest() {
      this.$v.amount.$touch();
      if (!this.$v.amount.$invalid && !this.isWarningMessage) {
        this.currentStep = STEPS.REVIEW;
      }
    },
    onEdit() {
      this.currentStep = STEPS.ENTER_AMOUNT;
    },
    onSuccess() {
      this.amount = '';
      this.selectedAccount = null;
      this.currentStep = STEPS.SELECT_ACCOUNT;
      this.checkWithdrawAch();
      this.$emit('success');
    },
    checkWithdrawAch() {
      this.getWithdrawAch()
        .then((data) => {
          this.checkDocumentUploadFlags(data);
          this.checkWarningFlags(data);
          this.isComponentReady = true;
        })
        .catch((error) => {
          this.isComponentReady = true;
          this.error = get(error, 'response.data.message', '');
        });
    },
  },
  created() {
    this.checkWithdrawAch();
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/withdraw-funds-linked-bank/withdraw-funds-linked-bank.js